export function normalizeArticleNumber(articleNumber: string): string {
  return articleNumber.replaceAll(/[.\-_\s]/g, "");
}
